import { Reducer } from 'redux';
import { IBeneficiaryDataAction } from '../actions/beneficiaryAction';
import { BeneficiaryActionTypes } from '../constants/actionTypes';
import { IBeneficiaryData } from '../types/BeneficiaryTypes';

// Define the initial state
const initialState: IBeneficiaryState = {
  beneficiaryData: undefined,
  beneficiaryErrors: undefined,
};

export interface IBeneficiaryState {
  readonly beneficiaryData: IBeneficiaryData | undefined;
  readonly beneficiaryErrors: string[] | undefined
}

export const beneficiaryReducer: Reducer<IBeneficiaryState,
IBeneficiaryDataAction> = (
  state = initialState,
  action: IBeneficiaryDataAction,
) => {
  switch (action.type) {
    case BeneficiaryActionTypes.GET_BENEFICIARY_DATA:
      return {
        ...state,
        beneficiaryData: action.beneficiaryData,
        beneficiaryErrors: undefined,
      };
    case BeneficiaryActionTypes.ERROR_GET_BENEFICIARY_DATA:
      return {
        ...state,
        beneficiaryData: undefined,
        beneficiaryErrors: action.beneficiaryErrors,
      };
    default:
      return state;
  }
};
